export default "__VITE_ASSET__CteCg4qm__"